import React from 'react';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { PopoverProps } from '@lightspeed/flame/Popover';

import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

const StyledBox = styled(Box)`
  display: inline-block;
  margin-left: 4px;
`;
interface Props {
  content?: React.ReactNode;
  placement?: PopoverProps['placement'];
}

const OverviewTooltip: React.FC<Props> = ({ content, placement }) => {
  if (!content) return null;

  return (
    <StyledBox>
      <TooltipHelp content={content} placement={placement || 'top'} />
    </StyledBox>
  );
};

export default OverviewTooltip;
